import { apiGet } from '../../api'

export const delete_survey = query => {
  return apiGet({
    endpoint: `stoplight/delete_survey${query}`
  })
}
